import axios from 'axios';

const AxiosInterceptor = axios.create({
	baseURL: process.env.REACT_APP_BASE_URL_HEARRO,
	// timeout: 15000,
});

// request interceptors
AxiosInterceptor.interceptors.request.use(
	config => {
		const tokenData = localStorage.getItem('dtx002token');
		if (!tokenData) {
			// 토큰이 없으면 Authorization 설정 없이 진행 (백엔드에서 401을 반환하도록 함)
			return config;
		}
		const parsed = JSON.parse(tokenData);
		if (parsed?.accessToken) {
			config.headers.Authorization = `Bearer ${parsed.accessToken}`;
		}

		// 이미지 조회 API(사용자 이미지 조회, 환자 이미지 조회)의 경우만 responseType을 blob으로 적용
		if (
			(config.url === '/staff/profile-img' || config.url === '/patient/profile-img') &&
			config.method === 'get'
		) {
			config.responseType = 'blob';
		}
		return config;
	},
	error => {
		return Promise.reject(error);
	},
);

let isTokenRefreshing = false;
let refreshSubscribers = [];

const onTokenRefreshed = accessToken => {
	// eslint-disable-next-line array-callback-return
	refreshSubscribers.map(callback => {
		callback(accessToken);
	});

	refreshSubscribers = [];
};

const addRefreshSubscriber = callback => {
	refreshSubscribers.push(callback);
};

AxiosInterceptor.interceptors.response.use(
	response => {
		return response;
	},
	async error => {
		if (error.response && error.response.status === 401) {
			const originalRequest = error.config;
			if (isTokenRefreshing === false) {
				isTokenRefreshing = true;
				const tokenData = localStorage.getItem('dtx002token');
				if (!tokenData) {
					window.location.reload();
					return Promise.reject(error);
				}
				const { refreshToken } = JSON.parse(tokenData);
				// token refresh 요청
				try {
					const resp = await axios.post(
						`${process.env.REACT_APP_AUTH_URL}/auth/token/refresh`,
						null,
						{
							params: { refreshToken },
							headers: {
								Authorization: null,
							},
						},
					);

					// 새로운 토큰 저장
					if (parseInt(resp.status / 200, 10) === 1) {
						localStorage.setItem('dtx002token', JSON.stringify(resp.data));

						// refresh 상태 해제
						isTokenRefreshing = false;

						originalRequest.headers.Authorization = `Bearer ${resp.data.accessToken}`;

						// 401로 실패했던 요청을 새로운 accessToken으로 재요청
						onTokenRefreshed(resp.data.accessToken);
						return AxiosInterceptor(originalRequest);
					} else {
						throw new Error('token refresh error');
					}
				} catch (e) {
					console.log(e);
					localStorage.removeItem('dtx002token');
					window.location.reload();
				}
			}
			const retryOriginalRequest = new Promise(resolve => {
				addRefreshSubscriber(accessToken => {
					originalRequest.headers.Authorization = `Bearer ${accessToken}`;
					resolve(AxiosInterceptor(originalRequest));
				});
			});
			return retryOriginalRequest;
		}
		return error;
	},
);

export default AxiosInterceptor;
